export enum eLpnState {
  Created = 1,
  Pending = 2,
  Finished = 3,
  Manage = 4 // Gestionar
}
